import type { Context } from "../../app/permissions";

/** While `/me` is unavailable every area shows, as for any other feature; the server still refuses. */
export const inboxAccess = (has: Context["has"]) => ({ canView: has("inbox.view"), canReply: has("inbox.reply"), canManage: has("inbox.manage") });
